module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/BC1039-7895d26486301ced53044f4a13585bac.png";